const escapeRegExp = (value) => value.replace(/[.+?^${}()|[\]\\]/g, "\\$&");

const patternMatches = (pattern, value) => {
    if (pattern === value) return true;
    if (!pattern.includes("*")) return false;
    const regex = new RegExp("^" + pattern.split("*").map(escapeRegExp).join(".*") + "$");
    return regex.test(value);
};

const tokenSatisfies = (granted, required) =>
    patternMatches(granted, required) || patternMatches(required, granted);

export const hasPermission = (granted, required) => {
    if (!Array.isArray(granted) || !required) return false;
    const requiredTokens = String(required).split(",").map((token) => token.trim()).filter(Boolean);
    return requiredTokens.some((req) => granted.some((grant) => tokenSatisfies(grant, req)));
};
